import { DefaultState } from '@src/redux/types'

import {
  INQUIRY_ALL,
  INQUIRY_ASSIGNED,
  INQUIRY_COMMENTS,
  INQUIRY_COMMENT_CREATE,
  INQUIRY_COMMENT_DELETE,
  INQUIRY_CREATE,
  INQUIRY_DELETE,
  INQUIRY_ITEM,
  INQUIRY_LIST,
  INQUIRY_PUBLIC_INFO,
  INQUIRY_UPDATE_STATUS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [INQUIRY_ALL]: DefaultState<`${typeof API.INQUIRY_ALL}`, 'get'>
  [INQUIRY_ASSIGNED]: DefaultState<`${typeof API.INQUIRY_ASSIGNED}`, 'get'>
  [INQUIRY_CREATE]: DefaultState<`${typeof API.INQUIRY_CREATE}`, 'post'>
  [INQUIRY_DELETE]: DefaultState<`${typeof API.INQUIRY_DELETE}{id}`, 'delete'>
  [INQUIRY_ITEM]: DefaultState<`${typeof API.INQUIRY}{id}`, 'get'>
  [INQUIRY_LIST]: DefaultState<`${typeof API.INQUIRY}`, 'get'>
  [INQUIRY_UPDATE_STATUS]: DefaultState<`${typeof API.INQUIRY_UPDATE_STATUS}`, 'post'>
  [INQUIRY_COMMENTS]: DefaultState<`${typeof API.INQUIRY_COMMENT}`, 'get'>
  [INQUIRY_PUBLIC_INFO]: DefaultState<`${typeof API.INQUIRY_PUBLIC_INFO}`, 'get'>
  [INQUIRY_COMMENT_CREATE]: DefaultState<`${typeof API.INQUIRY_COMMENT}`, 'post'>
  [INQUIRY_COMMENT_DELETE]: DefaultState<`${typeof API.INQUIRY_COMMENT}{id}`, 'delete'>
} = () => ({
  [INQUIRY_ALL]: defaultState(),
  [INQUIRY_ASSIGNED]: defaultState(),
  [INQUIRY_CREATE]: defaultState(),
  [INQUIRY_DELETE]: defaultState(),
  [INQUIRY_ITEM]: defaultState(),
  [INQUIRY_LIST]: defaultState(),
  [INQUIRY_UPDATE_STATUS]: defaultState(),
  [INQUIRY_COMMENTS]: defaultState(),
  [INQUIRY_PUBLIC_INFO]: defaultState(),
  [INQUIRY_COMMENT_CREATE]: defaultState(),
  [INQUIRY_COMMENT_DELETE]: defaultState(),
})
